/* eslint-disable camelcase */
import { ymPushEvent } from './ym';

export const pushServiceDisconnected = (name) => {
  ymPushEvent('ServiceDisconnectSuccess', {
    service_ev_: {
      service_disconnect: {
        beeline: name,
      },
    },
  });
};
